<template>
  <p class="ErrorMessageComponent" :id="id" role="alert" aria-live="assertive">
    <span class="error">{{ messages }}</span>
  </p>

  <!--
    <v-text-field
    class="ErrorMessageComponent"
    :error-messages="messages"/>
  -->
</template>

<script setup lang="ts">
defineProps({
  messages: {
    type: String,
    default: undefined
  },
  id: {
    type: String,
    default: undefined
  }
})
</script>

<style lang="scss" scoped>
.ErrorMessageComponent {
  overflow: hidden;

  .error {
    display: block;
    min-height: 1.6em;
    font-size: $font-size-s;
    color: $color-error;

    &:not(:empty) {
      @include gl-mx-animation-appear-from-top;
    }
  }

  // :deep(.v-input__control) {
  //   height: 0;
  //   opacity: 0;
  // }
}
</style>
